import { render } from "./loginWithSocialNetwork.html?vue&type=template&id=5a8e2bf4&scoped=true"
import script from "./LoginWithSocialNetwork.vue?vue&type=script&lang=ts"
export * from "./LoginWithSocialNetwork.vue?vue&type=script&lang=ts"

import "./loginWithSocialNetwork.scss?vue&type=style&index=0&id=5a8e2bf4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5a8e2bf4"

export default script